import { useState, useEffect, useMemo } from "react";
import PageLayout from "../../Layouts/PageLayout/PageLayout";
import TabsNavigation from "../../components/common/TabsNavigation/TabsNavigation";
import Button from "../../components/common/Button/Button";
import { FiDownload } from "react-icons/fi";
import CalendarioTab from "../../components/layout/Gestores/CalendarioTab/CalendarioTab";
import { getApiInstance } from "../../utils/api";
import { CiCircleCheck, CiClock1 } from "react-icons/ci";
import { CgDanger } from "react-icons/cg";
import Table from "../../components/common/Table/Table";
import MapComponent from "../../components/common/MapComponent/MapComponent";
import Modal from "../../components/common/Modal/Modal";
import Badge from "../../components/common/Badge/Badge";
import { useZone } from "../../context/ZoneContext";
import "./Gestores.scss";
import { mapList } from "../../utils/utils";

const columnasGestores = [
  { key: "codProveedor", label: "ID", visible: false },
  {
    key: "nombre",
    label: "Nombre",
    visible: true,
    sortable: true,
    isLink: true,
  },
  { key: "cif", label: "CIF", visible: true, sortable: true },
  { key: "localidad", label: "Localidad", visible: true, sortable: true },
  { key: "contacto", label: "Contacto", visible: true, sortable: true },
  { key: "telefono", label: "Teléfono", visible: true, sortable: true },
  { key: "eMail", label: "Email", visible: true, sortable: true },
  { key: "codEstado", label: "Estado", visible: true, sortable: true },
];

const filterFields = [
  { key: "nombre", label: "Nombre", type: "multiselect" },
  { key: "cif", label: "CIF", type: "multiselect" },
  { key: "localidad", label: "Localidad", type: "multiselect" },
  { key: "contacto", label: "Contacto", type: "multiselect" },
  { key: "telefono", label: "Teléfono", type: "multiselect" },
  { key: "email", label: "Email", type: "multiselect" },
];

// DATOS MOCK PARA GESTORES
const mockGestores = [
  {
    id: 1,
    nombre: "EcoGest Residuos S.L.",
    cif: "B12345678",
    direccion: "Calle Industrial, 123",
    localidad: "Madrid",
    contacto: "Juan Pérez",
    telefono: "91 234 56 78",
    eMail: "contacto@ecogest.com",
    codEstado: "VALIDADO",
    latitud: 40.4168,
    longitud: -3.7038,
    zona: 1,
  },
  {
    id: 2,
    nombre: "Gestión Verde Andalucía",
    cif: "B87654321",
    direccion: "Polígono San Pablo, Nave 45",
    localidad: "Sevilla",
    contacto: "María García",
    telefono: "95 456 78 90",
    eMail: "info@gestionverde.es",
    codEstado: "PENDIENTE",
    latitud: 37.3891,
    longitud: -5.9845,
    zona: 1,
  },
  {
    id: 3,
    nombre: "Residuos del Norte S.A.",
    cif: "A11223344",
    direccion: "Avenida de la Industria, 67",
    localidad: "Bilbao",
    contacto: "Carlos López",
    telefono: "94 567 89 01",
    eMail: "carlos.lopez@residuosnorte.com",
    codEstado: "INCIDENCIA",
    latitud: 43.2627,
    longitud: -2.9253,
    zona: 1,
  },
  {
    id: 4,
    nombre: "Mediterranean Waste Solutions",
    cif: "B55667788",
    direccion: "Carrer de la Tecnologia, 89",
    localidad: "Barcelona",
    contacto: "Laura Martín",
    telefono: "93 678 90 12",
    eMail: "laura@medwaste.cat",
    codEstado: "VALIDADO",
    latitud: 41.3851,
    longitud: 2.1734,
    zona: 1,
  },
  {
    id: 5,
    nombre: "Reciclajes Valencia S.L.",
    cif: "B99887766",
    direccion: "Polígono Industrial Fuente del Jarro",
    localidad: "Valencia",
    contacto: "Roberto Fernández",
    telefono: "96 789 01 23",
    eMail: "roberto@reciclajesvalencia.es",
    codEstado: "SIN_DATOS",
    latitud: 39.4699,
    longitud: -0.3763,
    zona: 1,
  },
  {
    id: 6,
    nombre: "Gestora Canaria de Residuos",
    cif: "B33445566",
    direccion: "Zona Industrial Las Torres, 12",
    localidad: "Las Palmas de Gran Canaria",
    contacto: "Ana Rodríguez",
    telefono: "92 890 12 34",
    eMail: "ana.rodriguez@gcresiduos.com",
    codEstado: "VALIDADO",
    latitud: 28.1248,
    longitud: -15.43,
    zona: 1,
  },
  {
    id: 7,
    nombre: "Tratamientos Ecológicos Galicia",
    cif: "B77889900",
    direccion: "Rúa da Sustentabilidade, 45",
    localidad: "Vigo",
    contacto: "Miguel Santos",
    telefono: "98 901 23 45",
    eMail: "miguel@ecogalicia.gal",
    codEstado: "PENDIENTE",
    latitud: 42.2328,
    longitud: -8.7226,
    zona: 1,
  },
  {
    id: 8,
    nombre: "Limpieza Industrial Extremadura",
    cif: "B44556677",
    direccion: "Carretera Nacional 430, km 15",
    localidad: "Badajoz",
    contacto: "Isabel Jiménez",
    telefono: "92 012 34 56",
    eMail: "isabel@limpiezaextremadura.com",
    codEstado: "INCIDENCIA",
    latitud: 38.8794,
    longitud: -6.9707,
    zona: 1,
  },
];

// DATOS MOCK PARA CERTIFICADOS
const mockCertificados = [
  {
    id: 1,
    gestorId: 1,
    gestorNombre: "EcoGest Residuos S.L.",
    fechaCertificado: "2024-01-15",
    fechaVencimiento: "2025-01-15",
    tipoCertificado: "Gestión de Residuos Peligrosos",
    estado: "VIGENTE",
    numeroExpediente: "EXP-2024-001",
  },
  {
    id: 2,
    gestorId: 1,
    gestorNombre: "EcoGest Residuos S.L.",
    fechaCertificado: "2024-02-20",
    fechaVencimiento: "2025-02-20",
    tipoCertificado: "Transporte de Residuos",
    estado: "VIGENTE",
    numeroExpediente: "EXP-2024-002",
  },
  {
    id: 3,
    gestorId: 2,
    gestorNombre: "Gestión Verde Andalucía",
    fechaCertificado: "2024-03-10",
    fechaVencimiento: "2024-12-31",
    tipoCertificado: "Gestión de Residuos No Peligrosos",
    estado: "POR_RENOVAR",
    numeroExpediente: "EXP-2024-003",
  },
  {
    id: 4,
    gestorId: 3,
    gestorNombre: "Residuos del Norte S.A.",
    fechaCertificado: "2023-12-01",
    fechaVencimiento: "2024-11-30",
    tipoCertificado: "Tratamiento de Residuos Industriales",
    estado: "VENCIDO",
    numeroExpediente: "EXP-2023-015",
  },
  {
    id: 5,
    gestorId: 4,
    gestorNombre: "Mediterranean Waste Solutions",
    fechaCertificado: "2024-06-15",
    fechaVencimiento: "2025-06-15",
    tipoCertificado: "Gestión Integral de Residuos",
    estado: "VIGENTE",
    numeroExpediente: "EXP-2024-007",
  },
];

export default function Gestores() {
  const [activeTab, setActiveTab] = useState("listado");
  const [gestores, setGestores] = useState([]);
  const [certificados, setCertificados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { selectedZone } = useZone();
  const [comunidades, setComunidades] = useState([]);
  const [paises, setPaises] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [residuos, setResiduos] = useState([]);
  const [selectedProveedores, setSelectedProveedores] = useState(new Set());
  
  const selectedItems = useMemo(
      () => gestores.filter((proveedor) => selectedProveedores.has(proveedor.codProveedor)),
      [gestores, selectedProveedores]
    );

  const fetchGestores = async () => {
    try {
      const api = getApiInstance();
      const response = await api.get(
        `/api/Proveedores/GetProveedoresByZona?CodZona=${selectedZone.value}`
      );

      setGestores(response.data);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar los gestores. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  const fetchCertificados = async () => {
    try {
      const api = getApiInstance();
      const response = await api.get(
        `/api/ProveedoresCentros/GetAllCertificados/${selectedZone.value}`
      );
      setCertificados(response.data);
    } catch (err) {
      console.error("Error al cargar los certificados:", err);
    }
  };

  const fetchComunidades = async () => {
    const api = getApiInstance();

    try {
      let comunidadesData = [];

      const response = await api.get(
        `/api/Comunidades/GetComunidadesByZona/${selectedZone.value}`
      );
      comunidadesData = response.data;

      setComunidades([
        ...mapList(
          comunidadesData,
          "comunidad",
          "codComunidad",
          "codComunidad",
          "codPais"
        ),
      ]);

      console.log("Comunidades data fetched:", comunidadesData);

      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las comunidades. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  const fetchPaises = async () => {
    const api = getApiInstance();

    try {
      let paisesData = [];

      const response = await api.get(
        `/api/Paises/GetPaisesByZona/${selectedZone.value}`
      );
      paisesData = response.data;

      setPaises(mapList(paisesData, "pais", "codPais", "codPais"));

      console.log("Paises data fetched:", paisesData);

      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar los países. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  const fetchProvincias = async () => {
    const api = getApiInstance();
    try {
      let provinciasData = [];

      const response = await api.get(
        `/api/Provincias/GetProvinciasByZona/${selectedZone.value}`
      );
      provinciasData = response.data;

      setProvincias([
        ...mapList(
          provinciasData,
          "provincia",
          "codProvincia",
          "codProvincia",
          "codComunidad"
        ),
      ]);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

  const fetchResiduos = async () => {
    const api = getApiInstance();
    try {
      let residuosData = [];

      const response = await api.get(
        `/api/Residuos/GetResiduosByZona/?codZona=${selectedZone.value}`
      );
      residuosData = response.data;

      setResiduos([
        ...mapList(residuosData, "nombre", "codResiduo", "codResiduo"),
      ]);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
    }
  };

useEffect(() => {
  let isMounted = true;
  setLoading(true);
  setError(null);

  const loadAll = async () => {
    try {
      await fetchGestores();

      await Promise.all([
        fetchCertificados(),
        fetchPaises(),
        fetchComunidades(),
        fetchProvincias(),
        fetchResiduos(),
      ]);
    } catch (err) {
      if (isMounted) {
        setError("No se han podido cargar los datos. Vuelve a intentarlo más tarde.");
      }
      console.error("Error en loadAll:", err);
    } finally {
      if (isMounted) setLoading(false);
    }
  };

  loadAll();

  return () => {
    isMounted = false;
  };
}, [selectedZone]);

  const tabs = [
    { id: "listado", label: "Listado" },
    { id: "mapa", label: "Mapa" },
    { id: "calendario", label: "Calendario" },
  ];

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const modalMap = (gestor) => {
    const getComplianceStatus = (gestor) => {
      switch (gestor.codEstado) {
        case 0:
          return { label: "Sin datos", type: "info", Icon: CiClock1 };
        case 1:
          return {
            label: "Pendiente",
            type: "info",
            Icon: CiClock1,
          };
        case 2:
          return {
            label: "Incidencia",
            type: "warning",
            Icon: CgDanger,
          };
        case 3:
          return {
            label: "Validada",
            type: "success",
            Icon: CiCircleCheck,
          };
        case 4:
          return {
            label: "Expirado",
            type: "danger",
            Icon: CiCircleCheck,
          };
        default:
          return { label: "Sin estado", type: "outlined" };
      }
    };

    const status = getComplianceStatus(gestor);

    return (
      <div className="gestor-map-details">
        <h3 className="modal-title">{gestor.nombre}</h3>
        <p className="gestor-location">{gestor.localidad}</p>

        <div className="gestor-map-details__info">
          <div className="info-row">
            <strong>Gestor:</strong> {gestor.nombre}
          </div>
          <div className="info-row">
            <strong>Contacto:</strong> {gestor.contacto || "No especificado"}
          </div>
          <div className="info-row">
            <strong>Teléfono:</strong> {gestor.telefono || "No especificado"}
          </div>
          <div className="info-row">
            <strong>Email:</strong> {gestor.eMail || "No especificado"}
          </div>
          <div className="info-row">
            <strong>Autorización:</strong> {gestor.cif}
          </div>
        </div>

        <div className="gestor-map-details__compliance">
          <div className="compliance-header">
            <h4 className="compliance-title">Cumplimiento Legal</h4>
            <Badge variant={status.type} Icon={status.Icon}>
              {status.label}
            </Badge>
          </div>

          <div className="compliance-item">
            {gestor.cumplimientos.map((cumplimiento, index) => {
              let statusText = "";
              let statusType = "info";
              if (cumplimiento.presentado === false) {
                statusText =
                  "Documento " + cumplimiento.nombre + " no presentado";
                statusType = "error";
              } else if (cumplimiento.caducado === true) {
                statusText = "Documento " + cumplimiento.nombre + " no vigente";
                statusType = "error";
              } else if (cumplimiento.codEstado === 1) {
                statusText =
                  "Documento " +
                  cumplimiento.nombre +
                  " pendiente de validación";
                statusType = "warning";
              } else if (cumplimiento.codEstado === 2) {
                statusText =
                  "Se han detectado incidencias en el documento " +
                  cumplimiento.nombre;
                statusType = "error";
              } else {
                statusText = "Documento " + cumplimiento.nombre + " en regla";
                statusType = "success";
              }

              return (
                <div key={index} className="compliance-row">
                  <div className={`status-dot status-dot--${statusType}`}></div>
                  <span className="status-text">{statusText}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="modal-actions">
          <Button
            variant="filled"
            onClick={() => {
              window.location.href = `/gestores/${gestor.codProveedor}`;
            }}
          >
            Ver Ficha Completa
          </Button>
          {/* <Button variant="outlined" onClick={closeMapModal}>
          Cerrar
        </Button> */}
        </div>
      </div>
    );
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "listado":
        return (
          <Table
            columns={columnasGestores}
            dataTable={gestores}
            keyProp="codProveedor"
            sortProp="nombre"
            showCheckboxes={true}
            noResultsMessage="No se han encontrado gestores."
            actions={["Eliminar", "Editar"]}
            searchTerms={[
              "Nombre",
              "CIF",
              "Localidad",
              "Contacto",
              "Teléfono",
              "Email",
            ]}
            filterFields={filterFields}
            elementName="Gestor"
            stateProp="codEstado"
            states={[
              {
                label: "Sin datos",
                type: "info",
                Icon: CiClock1,
              },
              {
                label: "Pendiente",
                type: "info",
                Icon: CiClock1,
              },
              {
                label: "Incidencia",
                type: "warning",
                Icon: CgDanger,
              },
              {
                label: "Validada",
                type: "success",
                Icon: CiCircleCheck,
              },
            ]}
            formElements={[
              {
                title: "Información General",
                titleVisible: true,
                elements: [
                  {
                    name: "nombre",
                    type: "text",
                    label: "Nombre",
                    placeholder: "Ingrese el nombre",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "cif",
                    type: "text",
                    label: "CIF",
                    placeholder: "Ingrese el CIF",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "contacto",
                    type: "text",
                    label: "Contacto",
                    placeholder: "Ingrese el nombre de contacto",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "telefono",
                    type: "tel",
                    label: "Teléfono",
                    placeholder: "Ingrese el número de teléfono",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "eMail",
                    type: "email",
                    label: "Email",
                    placeholder: "Ingrese la dirección de email",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "codsResiduos",
                    type: "multiselect",
                    options: residuos,
                    label: "Tipos de Residuos Gestionados",
                    placeholder: "Seleccione los tipos de residuos",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    withCheckbox: true,
                  },
                  {
                    name: "isGestorFinal",
                    type: "checkbox",
                    label: "Gestor final",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    defaultValue: false,
                  },
                  {
                    name: "isTransportista",
                    type: "checkbox",
                    label: "Transportista",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    defaultValue: false,
                  },
                ],
              },
              {
                title: "Ubicación",
                titleVisible: true,
                elements: [
                  {
                    name: "direccion",
                    type: "text",
                    label: "Dirección",
                    placeholder: "Ingrese la dirección",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "localidad",
                    type: "text",
                    label: "Localidad",
                    placeholder: "Ingrese la localidad",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "cp",
                    type: "text",
                    label: "Código Postal",
                    placeholder: "Ingrese el código postal",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "codPais",
                    type: "select",
                    label: "País",
                    placeholder: "Seleccione el país",
                    options: paises,
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                  },
                  {
                    name: "codComunidad",
                    type: "select",
                    label: "Comunidad",
                    placeholder: "Seleccione la comunidad",
                    options: comunidades,
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    associatedFormElement: "codPais",
                  },
                  {
                    name: "codProvincia",
                    type: "select",
                    label: "Provincia",
                    placeholder: "Seleccione la provincia",
                    options: provincias,
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    associatedFormElement: "codComunidad",
                  },
                  {
                    name: "codZona",
                    type: "number",
                    label: "Zona",
                    visible: false,
                    defaultValue: "1",
                  },
                ],
              },
            ]}
            loading={loading}
            addApiUrl="/api/Proveedores/SetProveedor"
            editApiUrl="/api/Proveedores/EditProveedor"
            deleteApiUrl="/api/Proveedores/DeleteProveedor"
            selectedRows={selectedProveedores}
            onSelectionChange={setSelectedProveedores}
          />
        );
      case "mapa":
        return (
          <MapComponent
            data={gestores}
            center={[42.0, 2.0]}
            zoom={5}
            height="600px"
            width="100%"
            modalContent={modalMap}
          />
        );
      case "calendario":
        return <CalendarioTab gestoresData={certificados} />;
      default:
        return null;
    }
  };

  const handleExportarSeleccionados = () => {
    if (selectedItems.length === 0) {
      alert("Por favor, selecciona al menos un proveedor para exportar.");
      return;
    }

    const codsProveedores = selectedItems.map(item => item.codProveedor);
        
    generateExcel({ codsProveedores });
  };

const generateExcel = async ({
  codsProveedores,
}) => {
  const api = getApiInstance(); 
  const codZona = selectedZone.value
  const codZonaLegal = 1

  try {
    const response = await api.post(
      '/api/Proveedores/CreateReportByCods',
      codsProveedores,
      {
        params: { codZona, codZonaLegal },
        responseType: 'blob',
      }
    );

    const contentDisposition = response.headers['content-disposition'];
    let fileName = 'Informe_Proveedores.xlsx';
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (fileNameMatch && fileNameMatch.length === 2) {
        fileName = fileNameMatch[1];
      }
    }

const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (err) {
    setError("No se pudo generar el reporte. Vuelve a intentarlo más tarde.");
    console.error(err);
  }
};

  return (
    <PageLayout
      title="Gestores"
      subtitle="Aquí verás la información de la empresa con la que se contacta para realizar las retiradas en obra"
      actions={[
        <Button
          key="export"
          componentType="button"
          variant="outlined"
          startIcon={<FiDownload />}
          onClick={handleExportarSeleccionados}
          disabled={selectedItems.length === 0}
        >
          Exportar gestores
        </Button>,
      ]}
    >
      <TabsNavigation
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      {error && (
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            fontSize: "16px",
            color: "#e74c3c",
            backgroundColor: "#fdf2f2",
            border: "1px solid #fecaca",
            borderRadius: "6px",
            margin: "10px 0",
          }}
        >
          {error}
        </div>
      )}

      {!error && renderTabContent()}
    </PageLayout>
  );
}
